export default function getBytescaleImageURL(path, width, height) {
  return `https://upcdn.io/${process.env.REACT_APP_BYTESCALE_ACCOUNT_ID}/image${path}?w=${width}&h=${height}`;
}

export function getBytescaleVideoURL(path) {
  return `https://upcdn.io/${process.env.REACT_APP_BYTESCALE_ACCOUNT_ID}/raw${path}?h=1080&f=mp4`;
}
